import { render, staticRenderFns } from "./FolderAlertOutline.vue?vue&type=template&id=0780345b"
import script from "./FolderAlertOutline.vue?vue&type=script&lang=js"
export * from "./FolderAlertOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports